import { EyeSlash, Info } from "@phosphor-icons/react";

/**
 * Shown on vendor-facing detail pages (jobs, emergency jobs, work orders, tasks) to
 * reassure the supplier that if something looks missing — client name, commercials,
 * margins — it's been intentionally hidden, not forgotten. Keeps the platform feeling
 * professional and transparent rather than buggy.
 */
export default function RedactionNotice({ compact = false, className = "" }) {
  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 border border-slate-200 dark:border-slate-700 ${className}`}
        title="Client details and commercials are intentionally hidden from the supplier view."
        data-testid="redaction-badge"
      >
        <EyeSlash size={11} weight="duotone" />
        Client details redacted
      </span>
    );
  }

  return (
    <div
      className={`flex items-start gap-2.5 p-3 rounded-md border border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-900/30 ${className}`}
      data-testid="redaction-notice"
    >
      <Info size={16} className="text-slate-500 mt-0.5 shrink-0" weight="duotone" />
      <div className="text-[11px] leading-relaxed">
        <p className="font-semibold text-slate-700 dark:text-slate-300">Client details redacted</p>
        <p className="text-slate-500 dark:text-slate-400 mt-0.5">
          Client names and commercial values (budgets, margins, invoice amounts) are hidden from the supplier view for privacy. You'll always see the property, on-site contact, and anything else you need to do the job.
        </p>
      </div>
    </div>
  );
}
